import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import Navbar from '../navbar/Navbar';
import './Notifications.css';
import '../form/ReactSelect.css';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { appendAlert } from "../../redux/alertSlice";

import { PlantCodeSelect } from '../ui/PlantCodeSelect';
import { ProcCodeSelect } from '../ui/ProcCodeSelect';
import { MachCodeSelect } from '../ui/MachCodeSelect';
import Footer from '../footer/Footer';

import Grid from '../grid/NotificationsGrid';
import Spinner from '../ui/Spinner';
import { GridApi } from 'ag-grid-enterprise';

import apiAxios from '../../utils/apiAxios';

const NotificationSnippet: React.FC = () => {

  const dispatch:AppDispatch = useDispatch();

  const plantCode = useSelector((state: RootState) => state.queryParams.selectedPlantCode); // 製造工場コード
  const procCode = useSelector((state: RootState) => state.queryParams.selectedProcCode); // 加工コード
  const machCode = useSelector((state: RootState) => state.queryParams.machCode); // 機械作業コード

  // 初期値を設定
  const [selectPlantCode, setSelectPlantCode] = useState(plantCode); // 工場コード
  const [selectedProcCode, setSelectedProcCode] = useState(procCode); // 加工コード
  const [selectedMachCode, setSelectedMachCode] = useState(machCode && machCode.length === 1 ? machCode[0] : ""); // 機械作業コード

  // セレクトボックスの変更を検知しstateの状態を更新
  // 工場コードの変更を検知
  const handlePlantCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectPlantCode(e.target.value);
    setSelectedProcCode("");
    setSelectedMachCode("");
  };

  // セレクトボックスの変更を検知しstateの状態を更新
  // 加工コードの変更を検知
  const handleProcCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMachCode("");
    setSelectedProcCode(e.target.value);
  };
  // 機械作業コードの変更を検知
  const handleMachCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMachCode(e.target.value);
  };

  // GridのAPI
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  // Gridの初期化時のコールバック
  const onGridReady = (params: { api: GridApi }) => {
    setGridApi(params.api);
    (async () => {
      let data = await getNotificationsList();
      params.api.applyTransaction({ add: data });
      params.api.sizeColumnsToFit();
    })();
  };

  const [isLoading, setIsLoading] = useState(true);

  // 通知一覧の取得
  const getNotificationsList = async () => {
    try {
      setIsLoading(true);
      const response = await apiAxios.get(`/notifications`, {
        // params: {
        //   proc_code: proc_code,
        //   mach_code: mach_code,
        // }
      });
      return response.data;
    } catch (error:any) {
      console.error(error);
      dispatch(appendAlert({
        severity:"error",
        message:"データの取得に失敗しました。" + error.message,
        displayTime: 5000
      },));
      return [];
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <Helmet>
        <title>Process Flow Manager</title>
      </Helmet>
      <Navbar />
      <div className="notifications-container">
        <div className="notifications-container-title">
          <img src="images/notifications-true.svg" alt="" />
          <h1>通知一覧</h1>
        </div>

        <div className="notifications-container-navi">

        <div className="notifications-container-navi-item">
            <PlantCodeSelect label='工場' 
                selectPlantCode={selectPlantCode} 
                handlePlantCodeChange={handlePlantCodeChange} />
          </div>

          <div className="notifications-container-navi-item">
            <ProcCodeSelect label='加工' 
                plantCode={selectPlantCode} 
                selectProcCode={selectedProcCode} 
                handleProcCodeChange={handleProcCodeChange} />
          </div>

          <div className="notifications-container-navi-item">
            <MachCodeSelect label='機械'
                plantCode={selectPlantCode}
                procCode={selectedProcCode}
                selectMachCode={selectedMachCode}
                handleMachCodeChange={handleMachCodeChange} />
          </div>
          
        </div>

        <div className="notifications-container-grid">
          {isLoading && <Spinner />}
          <Grid onGridReadyParent={onGridReady} />
        </div>

      </div>
      {/* フッター */}
      <Footer />
    </div>
  );
};

export default NotificationSnippet;
